import ReportAsync from './ReportAsync';
import { ReportAsyncGroup } from './ReportAsync/types';

const ReportSNIES = () => {
  return <ReportAsync group={ReportAsyncGroup.SNIES} />;
};

export default ReportSNIES;
